<template>
  <div id="top">
    <dd-header></dd-header>
    <main>
      <div id="left"><!-- @ メインコンテンツの左カラム -->
        <div class="notice">
          <!-- 重要情報 -->
          <span class="headnews">重要情報</span>
          <ul v-if="isExistImpInfo()">
            <li v-for="(imp,index) in impDataList" :key=index>
              <a href="#">{{ imp.opInfoTitle }}</a>
            </li>
          </ul>
          <ul v-else>
            <li>現在、重要情報はありません。</li>
          </ul>
          <!-- 新着情報 -->
          <span class="latestInfo">新着情報</span>
          <ul v-if="isExistLatestInfo()">
            <li v-for="(latest,index) in latestDataList" :key=index>
              <a href="#">{{ latest.opInfoStartdt }}  {{ latest.opInfoTitle }}</a>
            </li>
          </ul>
          <ul v-else>
            <li>現在、新着情報はありません。</li>
          </ul>
          <!-- お知らせ -->
          <span class="news">お知らせ</span>
          <ul v-if="isExistInfo()">
            <li v-for="(info,index) in infoDataList" :key=index>
              <a href="#">{{ info.opInfoStartdt }}  {{ info.opInfoTitle }}</a>
            </li>
          </ul>
          <ul v-else>
            <li>現在、お知らせはありません。</li>
          </ul>
           <!-- すべてのお知らせを見る -->
          <ul id="allnews" v-if="isExistInfo() || isExistLatestInfo()">
            <li>
              <a href="#">
                <img :src="getImage('pages/top/ic_allview.svg')" alt="allview" width="18px" height="auto" > 全てのお知らせを見る
                <!--  <i class='bx bx-chevron-down bx-sm weighty'></i>全てのお知らせを見る -->
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div id="right"><!-- @メインコンテンツの右カラム -->
        <ul class="button">
          <li class="button_main" :class="{display_output: !isUseOutput}">
            <div id="right-top">
              <div :class="{img_disable: !isUsePlanning}">
                <router-link to="/planning">
                  <img class="planning" :src="getImage('pages/top/ic_combut.svg')" alt="planning" width="150px" height="150px">
                  <h2>プランニング</h2>
                </router-link>
              </div>
              <div :class="{img_disable: !isUsePlanList}">
                <router-link to="/list">
                  <img class="list" :src="getImage('pages/top/ic_list.svg')" alt="property" width="120px" height="120px">
                  <span v-if="!isUsePropertyManagement">
                    <h2>プラン管理</h2>
                  </span>
                  <span v-if="isUsePropertyManagement">
                    <h2>物件管理</h2>
                  </span>
                </router-link>
              </div>
            </div>
          </li>
          <li v-if="isUseOutput" class="button_main2">
            <router-link to="/output">
              <img class="download" :src="getImage('pages/top/ic_output.svg')" alt="property" width="90px" height="90px">
              <span>
                <h2>出力物管理</h2>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </main>
    <dd-footer/>
  </div>
</template>
<script>
// Libraries
import axios from 'axios'
// Module
import {API_URL, NOTICE_IMP_MAX_COUNT, NOTICE_LATEST_MAX_COUNT, NOTICE_INFO_MAX_COUNT} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import Header from '../components/common/TopHeader'
import Footer from '../components/common/Footer'

export default {
  name: 'Top',
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
      /** お知らせ一覧 */
      infoDataList: [],
      /** 新着情報一覧 */
      latestDataList: [],
      /** 重要なお知らせ一覧 */
      impDataList: []
    }
  },
  computed: {
    isUsePlanning: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.topPlanning
    },
    isUsePlanList: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.topPlanList
    },
    isUseOutput: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.topOutput
    },
    /** 物件管理ライセンスフラグ */
    isUsePropertyManagement: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.topPropertyMng
    }
  },
  methods: {
    /** お知らせ情報取得 */
    getOpInfo: function () {
      axios.get(API_URL.TOP)
        .then(response => {
          let opInfoList = response.data.data
          for (let info in opInfoList) {
            if (opInfoList[info].opInfoType === 3 && this.impDataList.length < NOTICE_IMP_MAX_COUNT) {
              this.impDataList.push(opInfoList[info])
            } else if (opInfoList[info].opInfoType === 2 && this.latestDataList.length < NOTICE_LATEST_MAX_COUNT) {
              this.latestDataList.push(opInfoList[info])
            } else if (opInfoList[info].opInfoType === 1 && this.infoDataList.length < NOTICE_INFO_MAX_COUNT) {
              this.infoDataList.push(opInfoList[info])
            }
          }
          this.$nextTick(function () {
            this.getInfoHeight()
          })
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** お知らせ情報の高さ取得 */
    getInfoHeight: function () {
      let infoLng = this.infoDataList.length
      let impLng = this.impDataList.length
      let latestDataList = this.latestDataList.length
      if (impLng > 0) {
        document.querySelector('.headnews').style.height = (this.getInfoHeightCss * impLng) + 'px'
      }
      if (infoLng > 0 || latestDataList > 0) {
        if (infoLng > 0) {
          document.querySelector('.news').parentNode.style.height = (this.getInfoHeightCss * infoLng) + 'px'
        }
        if (latestDataList > 0) {
          document.querySelector('.latestInfo').parentNode.style.height = (this.getInfoHeightCss * infoLng) + 'px'
        }
        document.querySelector('#allnews li').style.lineHeight = document.querySelector('.news').parentNode.clientHeight + 'px'
      }
    },
    /** お知らせ情報cssの高さ取得 */
    getInfoHeightCss: function (element, property) {
      if (!element || !property) return null
      var style = window.getComputedStyle(element)
      var value = style.getPropertyValue(property)
      return parseInt(value)
    },
    /** 重要情報の存在チェック */
    isExistImpInfo: function () {
      if (!this.impDataList) return false
      if (this.impDataList.length <= 0) return false
      return true
    },
    /** 最新情報の存在チェック */
    isExistLatestInfo: function () {
      if (!this.latestDataList) return false
      if (this.latestDataList.length <= 0) return false
      return true
    },
    /** お知らせの存在チェック */
    isExistInfo: function () {
      if (!this.infoDataList) return false
      if (this.infoDataList.length <= 0) return false
      return true
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  created: function () {
    this.getOpInfo()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../css/top/top.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#top {
  background: #eee !important;
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #eee;
  font-size: 15px;
  font-family: "Avenir", "Helvetica Neue", "Helvetica", "Arial", YuGothic,
    "Yu Gothic", "Hiragino Sans", "ヒラギノ角ゴシック", "メイリオ", Meiryo,
    "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  height: 100%;
  min-width: 1020px;
  min-height: 800px;
}
main {
  max-width: 1300px;
  min-height: calc(100% - 151px);
  margin: 0 auto;
  display: flex !important;
}
h3 {
  font-size: 1rem !important;
}
a {
  color: #000 !important;
}
a:hover {
  color: #ff4500 !important;
}
.logout a {
  color: rgb(255, 255, 255) !important;
}
.hddw_nav li:first-child {
  margin-right: auto;
  font-weight: bold;
  padding-left: 47px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Top.vue